"use client";

import { QuestionnaireContainer } from "./components/QuestionnaireContainer";

export default function DocumentChecklist() {
  return (
    <main className="flex-1">
      <QuestionnaireContainer />
    </main>
  );
} 